<div class="w-full flex justify-between items-center p-4 bg-gray-100">
  <div class="flex gap-2">
    @if (iconPath()) {
      <app-icon [path]="iconPath()!" />
    }

    <span class="text-lg font-md text-inherit">
      {{ title() }}
    </span>
  </div>

  <app-close-button (close)="onClose()" />
</div>
